import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "replyFilled"
const ReplyFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.188 15.375C18.188 12.579 15.92 10.313 13.125 10.313H6.763L10.413 13.963 9.087 15.287 3.174 9.375 9.087 3.462 10.413 4.788 6.763 8.438H13.125C16.956 8.438 20.063 11.543 20.063 15.375V20.25H18.188z" />
        </svg>
      }
    </span>
  )
}
export default ReplyFilledIcon
